/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type { IMinter, IMinterInterface } from "../IMinter";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "dungeonBiomeLevel",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "heroLevel",
        type: "uint256",
      },
    ],
    name: "amountForDungeon",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "dungeonId",
        type: "uint64",
      },
      {
        internalType: "uint256",
        name: "dungeonBiomeLevel",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "heroLevel",
        type: "uint256",
      },
    ],
    name: "mintDungeonReward",
    outputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

export class IMinter__factory {
  static readonly abi = _abi;
  static createInterface(): IMinterInterface {
    return new Interface(_abi) as IMinterInterface;
  }
  static connect(address: string, runner?: ContractRunner | null): IMinter {
    return new Contract(address, _abi, runner) as unknown as IMinter;
  }
}
